import {get } from "../../pwa/ajax";
import * as BucketTools from "../common/bucket";
import * as Utilities from "../common/utilities";
import * as Session from "../common/session";
import { prioridadTag } from "../../../Settings/global/home.json";

const urlBucket = window.config.Statics.BucketUrl;
const siteIdLF = window.config.Statics.SiteIdLF;
const loginUrl = window.config.Statics.LoginUrl;
const loginUrlCallback = loginUrl + window.btoa(location.href);
let liveFireUrlApi = window.config.Statics.ApiLiveFireUrl;
const urlNavAninima = window.config.Statics.ApiNavAnonimaHome;

export const preferencias = () => {
    if (Session.init()) {
        preferenciasTrigger();
    } else {
        //NO LOGUEADO
        renderDataNoLogueado(5, getTemasYAutores);
    }
};

const preferenciasTrigger = () => {
    //Personalizacion.initPreferencias().then(function(result) {
    if (localStorage.getItem("obtenerHashSuscripciones") != null) {
            obtenerDatosPreferencias(true,
                renderPreferencias); //Obtener las Preferencias y competando con sugerencias llegado el caso.
        } else { //SIN PREFERENCIAS
            obtenerDatosSugerencias(false,
                renderSugerencias); //Obtener sugerencias pero NO completar con preferencias llegado el caso.
        }
    //});
}

//Prefgerencias
const obtenerDatosPreferencias = (rellenar, callback) => {
    callback(JSON.parse(localStorage.getItem("obtenerPorPrioridad")), localStorage.getItem("obtenerNovedades"), JSON.parse(localStorage.getItem("recomendarTemas")));
}

//Sugerencias
const obtenerDatosSugerencias = (rellenar, callback) => {
    callback(JSON.parse(localStorage.getItem("obtenerPorPrioridad")), JSON.parse(localStorage.getItem("recomendarTemas")));
}

const renderPreferencias = (preferencias, cantNotasNoLeidas, temasRecomendados) => {
    let html = "";

    //CON notas a leer. (si hay pocas, completa con Sugerencias)
    if (cantNotasNoLeidas > 0) {
        html += `<div class="logueado-solo">
                    <div class="techo-2 floatFix">
                    <span>Temas y autores que seguís:
                            <b>
                                <span>${cantNotasNoLeidas}</span> notas nuevas
                            </b>
                        </span>
                    </div>`;
        //Articles
        html += loopArticles(preferencias, 8);
        html += `<div class="botones">
                    <a href="/lo-que-sigo">VER MÁS TEMAS <label class="desktop"> Y AUTORES</label></a>
                    <a class="desktop" href="/lo-que-sigo">CONFIGURAR</a>
                </div>
                </div>`;
    } else if (preferencias.length === 0) {
        //SIN preferencias NI Sugerencias.
        html += `<div class="logueado-sin-preferencias">
                    <div class="techo-2 floatFix">
                        <span>
                            Seguí los Temas y autores<b> que más te interesan</b>
                        </span>
                    </div>
                    <div class="instrucciones">
                        <div class="izquierda">
                            <article>
                                <h2>
                                    <span>Buscá el botón </span>
                                    <div class="seguir">SEGUIR</div>
                                    <span>para guardarlos y enterate al instante cada vez que haya notas nuevas.</span>
                                </h2>
                            </article>
                            <article><h2><span>Encontrá este botón en las notas y listados de temas y autores. </span></h2></article>
                            <article><h2><span>Cada vez que publiquemos notas nuevas, podrás encontrarlas aquí o en tu e-mail.</span></h2></article>
                        </div>`;

        html += renderTemasRecomendados(temasRecomendados);

        html += `<div class="botones">
                    <a href="/lo-que-sigo">VER MÁS TEMAS Y AUTORES</a>
                    <a href="/lo-que-sigo">CONFIGURAR</a>
                </div>
                </div>
                </div>`;
    } else {
        //SIN nota a leer (Llenar con SUGERENCIAS)
        html += `<div class="logueado-con-preferencias-no-notas-nuevas">
                    <div class="techo-2 floatFix">
                        <span> Temas y autores <b>que seguís</b></span>
                    </div>`;
        //Articles
        html += loopArticles(preferencias, 8);
        html += `<div class="botones">
                    <a href="/lo-que-sigo">VER MAS TEMAS Y AUTORES</a>
                    <a href="/lo-que-sigo">CONFIGURAR</a>
                </div>
                </div>`;
    }
    document.querySelector("#que-sigo").innerHTML = html;
}

const renderSugerencias = (sugerencias, temasRecomendados) => {
    let html = "";
    if (sugerencias != null && sugerencias.length > 0) {
        html += `<div class="logueado-sin-preferencias">
                    <div class="techo-2 floatFix">
                        <span>Seguí los Temas y autores<b> que más te interesan</b></span>
                    </div>
                    <div class="instrucciones">
                        <div class="izquierda">
                            <article>
                                <h2>
                                    <span>Buscá el botón </span>
                                    <div class="seguir">SEGUIR</div><span>para guardarlos y enterate al instante cada vez que haya notas nuevas.</span>
                                </h2>
                            </article>
                            <article><h2><span>Encontrá este botón en las notas y listados de temas y autores. </span></h2></article>
                            <article><h2><span>Cada vez que publiquemos notas nuevas, podrás encontrarlas aquí o en tu e-mail.</span></h2></article>
                        </div>`;

        html += renderTemasRecomendados(temasRecomendados);

        html += `</div>`;
        html += loopArticles(sugerencias, 6);
        html += `</div>`;
        document.querySelector("#que-sigo").innerHTML = html;
    }
}

const renderTemasRecomendados = (temas) => {
    let html = "";

    if (temas.length > 0) {
        html = `<div class="derecha">
                    <b>MIENTRAS TANTO, TE SUGERIMOS LOS SIGUIENTES TEMAS Y AUTORES</b>
                    <div class="relacionados">
                        <div>`;

        for (let temaAutor of temas) {
            html += `<a href="${Utilities.formatoUrlAcuTag(temaAutor[5], temaAutor[0])}">${temaAutor[5]}</a>`;
        }

        html += `</div>
                </div>
                </div>`;
    }
    return html;
}

const loopArticles = (notas, cantidadATomar) => {
    const valueToSlice = notas.length < cantidadATomar ? notas.length : cantidadATomar;
    notas = notas.filter(n => n.datos != undefined);
    
    let html = "";
    let toi = 301;
    for (let nota of notas.slice(0, valueToSlice)) {
        const notaDato = nota.datos;
        const esNotaOpinion = notaDato.template.id === 3;
        let imagenSrc = "";
        let autorUrl = "";

        if (esNotaOpinion) {
            if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores.length > 0 && notaDato.autores[0].imagen !== undefined && notaDato.autores[0].imagen != null && notaDato.autores[0].imagen.id > 0 && notaDato.autores[0].imagen.extension != null && notaDato.autores[0].imagen.extension != "") {
                imagenSrc = `<img src="${BucketTools.urlBucketBalance(urlBucket, notaDato.autores[0].imagen.id, "", 90, notaDato.autores[0].imagen.extension)}"/>`;
            } 

            if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores.length > 0) {
                const url = Utilities.formatoUrlAcuAutor(notaDato.autores[0].nombre, notaDato.autores[0].id);
                autorUrl = `<a href="${url}" class="nombre">${notaDato.autores[0].nombre}</a>`; 
            }
                
            
        } else {
            imagenSrc = (notaDato.imagen && notaDato.imagen !== undefined && notaDato.imagen != null && notaDato.imagen.id > 0 && notaDato.imagen.extension != null && notaDato.imagen.extension != "") ?
                `<img src="${BucketTools.urlBucketBalance(urlBucket, notaDato.imagen.id, 280, "", notaDato.imagen.extension)}"/>` :
                "";
        }

        const notaUrl = nota.contenido_id + "-" + Utilities.FormatearUrl(nota.titulo),
            tags = notaDato.temas;
        let tag;
        let tagHtml = "";

        if (tags && tags.length > 0) {
            //TODO: esto despues tiene que ser borrado ya que servicio tiene que enviar el primer objeto completo.
            const prioridaTagConfigHome = prioridadTag;
            tag = tags[0].formatoId === undefined ? tags[0] : Utilities.getTagPrioritario(tags, prioridaTagConfigHome);

            if (tag !== undefined) { //En el caso de que el unico tag sea formatoId = 2 o que no haya tags que conincidan con los tags de la config
                tagHtml = `<h3 class="tag"><a href="${Utilities.formatoUrlAcuTag(tag.descripcion, tag.id)}">${tag.descripcion}</a></h3>`;
            }
        }
        let toiPos = "toi".concat(toi.toString());
        let esSugerencia = nota.origen === "Sugerencia" ? esSugerencia = "recomendada" : esSugerencia = ""; 
        html += `<article title="" class="m noticia tema${esNotaOpinion ? " autor" : " foto"} floatFix ${esSugerencia}" data-id="${nota.contenido_id}" data-notaid="${nota.contenido_id}" data-source="${nota.origen}" data-pos="${toiPos}">
                    <a href="${notaUrl}" class="figure">
                        ${imagenSrc}
                    </a><div class="titulo">`;

        if (!esNotaOpinion) {
            html += `<h2>
                        <a href="${notaUrl}">${nota.titulo}</a>
                        </h2>`;
            html += tagHtml;
        } else {
            html += tagHtml;
            html += `<h2>
                        <a href="${notaUrl}">${nota.titulo}</a>
                        </h2>
                        ${autorUrl}`;
        }
        html += `</div></article>`;
        toi++;
    }
    return html;
}

////TODO: Unificar con el mismo metodo de notasAdicionales.js, no se hizo ahora por tema de tiempo.
const renderDataNoLogueado = (cantNotas, callback) => {
    liveFireUrlApi = liveFireUrlApi.replace("{livefyre-domainName}", "la-nacion");
    liveFireUrlApi = liveFireUrlApi.replace("{SiteId_Livefyre}", siteIdLF);
    liveFireUrlApi = liveFireUrlApi.replace("{cantidad de notas}", cantNotas);

    get(liveFireUrlApi)
        .then(rs => JSON.parse(rs))
        .then(callback);
}

const getTemasYAutores = (notasMasComentadas) => {
    let resp;
    get(urlNavAninima)
        .then(rs => {
            resp = JSON.parse(rs);
            renderNotasNoLogueado(notasMasComentadas, resp);
        });
}

const renderNotasNoLogueado = (notasMasComentadas, temasYAutoresAnonimos) => {
    const notasTemasRecomendados = temasYAutoresAnonimos.items.filter(nota => nota.tagDestacado);
    const notasAutoresRecomendados = temasYAutoresAnonimos.items.filter(nota => nota.autores.find(autor => autor !== null));

    let html = `<div class="no-logueado">
                    <div class="sin-loguear">
                        <div class="izquierda">
                            <div class="techo-2 floatFix">
                               <span>REGISTRATE EN LA NACION <br> Y <b>MEJORÁ TU EXPERIENCIA</b></span>
                            </div>
                        </div>
                        <a href="${loginUrlCallback}" class="boton">REGISTRATE</a>
                        <b class="resgristate">Al registrarte con tu red social o tu e-mail podés:</b>
                    </div>
                    <div class="secciones">
                        <span class="icon-seguir-1 fondo-amarillo"></span>
                        <h4>
                            Seguir los temas y autores que más te interesan
                            <span>y enterarte, al instante, cada vez que haya nuevas notas</span>
                        </h4>
                        <div class="relacionados izquierda">
                            <h5>AUTORES MÁS SEGUIDOS</h5>
                            <div>`;
    
    //AUTORES (3)
    if (notasAutoresRecomendados !== null && notasAutoresRecomendados !== undefined && notasAutoresRecomendados.length > 0) {
        const valueToSlice = notasAutoresRecomendados.length < 3 ? notasAutoresRecomendados.length : 3;
        for (let nota of notasAutoresRecomendados.slice(0, valueToSlice)) {
            html += `<a href="${Utilities.formatoUrlAcuAutor(nota.autores[0].valor, nota.autores[0].id)}">${nota.autores[0].valor}</a>`;
        }
    }

    html += `</div>
                </div>
                <div class="relacionados derecha ">
                    <h5>TEMAS MÁS SEGUIDOS</h5>
                <div>`;

    //TEMAS (3)
    if (notasTemasRecomendados !== null && notasTemasRecomendados !== undefined && notasTemasRecomendados.length > 0) {
        const valueToSlice = notasTemasRecomendados.length < 3 ? notasTemasRecomendados.length : 3;
        for (let nota of notasTemasRecomendados.slice(0, valueToSlice)) {
            html += `<a href="${Utilities.formatoUrlAcuTag(nota.tagDestacado.valor, nota.tagDestacado.id)}">${nota.tagDestacado.valor}</a>`;
        }
    }

    html += `</div>
                </div>
                    </div>
                    <div class="secciones">
                        <span class="icon-mail2 fondo-amarillo fixLeft"></span>
                        <h4>Suscribirte y recibir nuestros newsletters </h4>
                        <div class="list fixLeft">
                            <p>Alertas de noticias</p>
                            <p>Lo que hay que saber hoy y muchos más…</p>
                            <p>Lo que pasó en el día</p>
                            <p>Titulares de tapa</p>
                        </div>
                    </div>
                    <div class="secciones">
                        <span class="icon-comentario fondo-amarillo"></span>
                        <h4>Participar activamente con tu comentario en el debate de nuestra comunidad</h4>`;

    if (notasMasComentadas.data.length > 0) {
        html += `<section class="mas-leidas" data-is-block="true" data-block-name="h_mas-leidas-logout" data-diagramacion-id="0">
                        <div class="techo-2 floatFix">
                            <span>NOTAS 
                                <b>MÁS COMENTADAS</b>
                            </span>
                        </div>`;
        let toi = 351;
        for (let nota of notasMasComentadas.data) {
            const parts = nota.url.split("/");
            let url = parts.pop();
            let idNota = url.split("-")[0];
            let toiPos = "toi".concat(toi.toString());
            html += `<article class="noticia foto flo atFix" data-id="${idNota}" data-notaid="${idNota}" data-source="livefyre" data-pos="${toiPos}">
                            <h2>
                                <a href="/${url}">${nota.title}</a>
                            </h2>
                        </article>`;
            toi++;
        }

        html += `</section>
                    </div>
                        <div class="secciones">
                            <p>Disfrutá de los beneficios de navegar registrado, <br>mejorá tu experiencia y <b>¡mantenete siempre informado! </b></p>
                            <a href="${loginUrlCallback}" class="boton">INGRESAR</a>
                        </div>
                    </div>`;
    }
    document.querySelector("#que-sigo").innerHTML = html;
}


// WEBPACK FOOTER //
// ./Statics/scripts/home/loQueSigo.js